import React, { FC } from 'react';

// Styles
import './experience-profile.scss';

type TExperienceProfileProps = {};

export const ExperienceProfile: FC<TExperienceProfileProps> = (
  {}: TExperienceProfileProps
) => {

  return (
    <div className="experience-profile">
      experience-profile
    </div>
  );
}
